<div class="container-botoes">
  <app-botao-home (voltarHome)="onVoltarHome()"></app-botao-home>
  <app-botao-topo (scrollToTop)="onScrollToTop()"></app-botao-topo>
</div>
